import { render } from "./KatexContent.vue?vue&type=template&id=ecd2d2d0&scoped=true"
import script from "./KatexContent.vue?vue&type=script&lang=js"
export * from "./KatexContent.vue?vue&type=script&lang=js"

import "./KatexContent.vue?vue&type=style&index=0&id=ecd2d2d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecd2d2d0"]])

export default __exports__